import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
// import Testimonials from './components/Testimonials';
// import CTA from './components/CTA';
import Footer from './components/Footer';
// import BarCompare from './components/BarCompare';
import ProductStory from './components/ProductStory';
import ContactInfo from './components/ContactInfo';
import FunctionDetails from './components/FunctionDetails';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero id="home" />
      <Features id="features" />
      <FunctionDetails id="function-details" />
      {/* <UseCases /> */}
      {/* <Testimonials id="testimonials" /> */}
      {/* <BarCompare id="bar-compare" /> */}
      <ProductStory id="about" />
      {/* <ContactInfo id="contact" /> */}
      {/* <CTA /> */}
      <Footer />
    </div>
  );
}

export default App; 